import { render, staticRenderFns } from "./TheCartWidget.vue?vue&type=template&id=5be9e7ba&"
import script from "./TheCartWidget.vue?vue&type=script&lang=js&"
export * from "./TheCartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports